(() => {
  function init(root = document) {
    root.querySelectorAll('[data-mp-variant-select]').forEach(select => {
      if (select.dataset.ready) return;
      select.dataset.ready = 'true';
      const scope = select.closest('.mp-product');
      function update(changeUrl) {
        const option = select.selectedOptions[0];
        if (!option) return;
        scope.querySelector('[data-mp-price]').textContent = option.dataset.price;
        const button = scope.querySelector('button[name="add"]');
        button.disabled = option.dataset.available !== 'true';
        button.textContent = button.disabled ? 'Zurzeit nicht verfügbar' : 'In den Warenkorb';
        const image = scope.querySelector('#mp-main-image');
        if (image && option.dataset.image) {
          image.removeAttribute('srcset');
          image.src = option.dataset.image;
          image.alt = option.dataset.alt || '';
          scope.querySelector('#mp-image-caption').textContent = image.alt;
        }
        scope.querySelectorAll('[data-mp-image]').forEach(thumb => {
          const sizes = thumb.dataset.mpSizes;
          thumb.hidden = !!sizes && sizes !== '*' && !sizes.includes('|' + option.dataset.title + '|');
          thumb.setAttribute('aria-pressed', String(thumb.dataset.mpImage === option.dataset.image));
        });
        const contents = scope.querySelector('[data-mp-startset-contents]');
        if (contents) {
          const title = option.dataset.title;
          const leds = title === 'CUBE' ? 8 : ['NANO CUBE', 'ROCKET'].includes(title) ? 4 : 10;
          contents.textContent = title + ' + ' + leds + ' RGBW-LEDs + Core mit Netzteil und USB-C-Kabel (1 m)';
        }
        if (changeUrl) {
          const url = new URL(location.href);
          url.searchParams.set('variant', option.value);
          history.replaceState(null, '', url);
        }
      }
      select.addEventListener('change', () => update(true));
      update(false);
    });
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
